import React from "react";
import { Dispatch, SetStateAction } from "react";
import { Button, Typography, Dialog }  from "@material-tailwind/react";
import { FormProvider, useForm } from 'react-hook-form'

import { Part } from "../../../../redux/vehicles/actions";
import FormInput from "../../../../components/FormInput";
import { name_validation, title_validation } from "../../../../utils/inputValidations";


interface DialogRequestPartProps {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    onSubmit: (part: Part) => void;
}

export const DialogRequestPart: React.FC<DialogRequestPartProps> = ({
    isOpen,
    setIsOpen,
    onSubmit,
}) => {
    const methods = useForm();

    const onFormSubmit = methods.handleSubmit(data => {
        onSubmit(data);
    });

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen} size="md">
            <Dialog.Overlay>
                <Dialog.Content className="p-0 md:p-5">
                    <div className="flex flex-col gap-1 p-6 border-b border-surface">
                        <Typography type="h5" color="default">
                            Request Part
                        </Typography>
                        <Typography type="small" color="default" className="font-normal">
                            Fill in the details to request a new part
                        </Typography>
                    </div>
                    <FormProvider {...methods}>
                        <form
                            className="flex flex-col p-6"
                            onSubmit={(e) => e.preventDefault()}
                            noValidate
                            autoComplete="off"
                        >
                            <FormInput
                                {...name_validation}
                                name="name"
                                label="Part Name"
                                labelClass="mb-2 font-medium text-sm"
                                placeholder="Engine Oil Filter"
                            />
                            <FormInput
                                {...name_validation}
                                name="number"
                                label="Part Number"
                                labelClass="mb-2 font-medium text-sm"
                                placeholder="CAR-ENG-004"
                            />
                            <FormInput
                                {...name_validation}
                                label="Quantity"
                                labelClass="mb-2 font-medium text-sm"
                                name="qty"
                                placeholder="1"
                            />
                            <FormInput
                                {...title_validation}
                                name="note"
                                label="Notes"
                                labelClass="mb-2 font-medium text-sm"
                                multiline={true}
                                inputClass="!border-t-blue-gray-200 focus:!border-t-primary"
                                placeholder="For Toyota Avanza 2018, black color preferred if available. Ensure compatibility with the specific model and year. Please prioritize OEM parts or provide equivalent high-quality alternatives. If not in stock, provide estimated delivery time."
                            />
                        </form>
                    </FormProvider>
                    <div className="flex gap-3 justify-end p-6 border-t border-surface">
                        <Button
                            variant="outline"
                            color="secondary"
                            onClick={() => setIsOpen(false)}
                            className="mr-1"
                        >
                            Cancel
                        </Button>
                        <Button variant="solid" color="primary" onClick={onFormSubmit}>
                            Confirm
                        </Button>
                    </div>
                </Dialog.Content>
            </Dialog.Overlay>
        </Dialog>
    );
};